// LoadingScreen.jsx
import React, { useEffect, useContext, useState } from 'react';
import './Loading.css';
import '../src/styles/font.css';
import { ScreenContext } from './App';


let handleZIndexChangeLoadingExport; 

const Loading = () => {

  const [zIndex, setZIndex] = useState(1000); // Initial z-index value
  const [visible, setVisible] = useState(true); // Initial visibility state

  const handleScreenChange = useContext(ScreenContext);

  useEffect(() => {

   console.log(`Loading Screen Z Index Changed ====> ${zIndex}`);
   
  }, [zIndex]);

  useEffect(() => {
    console.log(`Initial Z Index of Loading Screen ====> ${zIndex}`);
  }, []); // Empty dependency array ensures the effect runs only once after mounting

  // You can adjust the zIndex value as needed
  //const zIndex = -1;

  const handleZIndexChange = (isAutoPlayDice) => {
    
   // console.log( )
    // console.log('Handle Z Index is Called || Player Selecion Screen');
     // Change the z-index value
     if(zIndex === 1000){
       console.log('Setting Z Index to Negative');
        setZIndex(-1000);
        setVisible(false);
     }
     
     if(zIndex === -1000){
        console.log('Setting Z Index to Positive');
        setZIndex(1000);
        setVisible(true);
     }
     
 
     //console.log(`Loading Screen ZIndex ====> ${zIndex}`);
   };


   handleZIndexChangeLoadingExport = handleZIndexChange;

  return (
    
    <div className="loading-screen" style={{ zIndex, visibility: visible ? 'visible' : 'hidden' }}>

    {/*style={{zIndex }} */}  
        
         {/* Your Logo */}
         <img
          src={require('./Assets/Images/AppDashboard/SplashScreen/gameLogo.png')}
          alt="Logo"
          className="logo-image"
        />

        <div style={{ position: 'absolute', bottom: '5%', width:'100%', textAlign: 'center', color: 'white', fontSize: '3vw ', fontFamily: 'Gomarice'}}>Loading...</div>

       
    </div>
  );
};

export {handleZIndexChangeLoadingExport};
export default Loading;